import { render, staticRenderFns } from "./TastingNotes.vue?vue&type=template&id=3ba42bfa"
import script from "./TastingNotes.vue?vue&type=script&lang=js"
export * from "./TastingNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports